import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
    providedIn: 'root',
})
export class CodeEnforcementService {
    constructor(private httpClient: HttpClient) { }

    fetchAllViolations(): Observable<any> {
        return this.httpClient.get('api/codeEnforcement/fetchAllViolations').pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                } else {
                    return body;
                }
            })
        )
    }

    fetchAllDaysToCure(): Observable<any> {
        return this.httpClient.get('api/codeEnforcement/fetchAllDaysToCure').pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                } else {
                    return body;
                }
            })
        )
    }

    fetchAllCategories(): Observable<any> {
        return this.httpClient.get('api/codeEnforcement/fetchAllCategories').pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                } else {
                    return body;
                }
            })
        )
    }

    createCase(data): Observable<any> {
        return this.httpClient.post('api/codeEnforcement/createCase',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }

    fetchAllCases(data?): Observable<any> {
        return this.httpClient.post('api/codeEnforcement/fetchAllCases',
        { data })
        .pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                } else {
                    return body;
                }
            })
        )
    }

    fetchAllCasesbyFilters(data): Observable<any> {
        return this.httpClient.post('api/codeEnforcement/fetchAllCasesbyFilters', { data }).pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                } else {
                    return body;
                }
            })
        )
    }

    fetchStatus(): Observable<any> {
        return this.httpClient.get('api/codeEnforcement/fetchStatus').pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                } else {
                    return body;
                }
            })
        )
    }

    updateCaseList(data): Observable<any> {
        return this.httpClient.post('api/codeEnforcement/updateCaseList',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }

    
    fetchAllExpiredCases(): Observable<any> {
        return this.httpClient.get('api/codeEnforcement/fetchAllExpiredCases').pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                } else {
                    return body;
                }
            })
        )
    }

    fetchCaseCategories(): Observable<any> {
        return this.httpClient.get('api/codeEnforcement/fetchCaseCategories').pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                } else {
                    return body;
                }
            })
        )
    }
    
    deleteCaseById(data): Observable<any> {
        return this.httpClient.post('api/codeEnforcement/deleteCaseById',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }
    

}